import { ItemsRecap } from "./ItemsRecap";

export default ItemsRecap;
